import { Mail, MapPin, Phone, Facebook, Instagram, Youtube, Twitter } from 'lucide-react';
import { Link } from 'react-router-dom';

const SOCIAL_LINKS = [
  {
    name: 'YouTube',
    href: 'https://www.youtube.com/c/pastordavidogbueli',
    icon: <Youtube className="h-5 w-5" />,
    label: 'YouTube',
  },
  {
    name: 'Facebook',
    href: 'https://web.facebook.com/pastordavidogbueli',
    icon: <Facebook className="h-5 w-5" />,
    label: 'Facebook',
  },
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/in/drdavidogbueli/',
    icon: (
      <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg>
    ),
    label: 'LinkedIn',
  },
  {
    name: 'Twitter',
    href: 'https://www.twitter.com/pstdavidogbueli',
    icon: <Twitter className="h-5 w-5" />,
    label: 'Twitter / X',
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/pastordavidogbueli',
    icon: <Instagram className="h-5 w-5" />,
    label: 'Instagram',
  },
  {
    name: 'Telegram',
    href: 'http://t.me/dominioncityglobal',
    icon: (
      <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
        <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.338 1.878-.338 1.954a.75.75 0 0 0 1.196.698l5.132-3.349a1.12 1.12 0 0 0 .381-.929l-.32-3.046c-.016-.17.043-.31.2-.37l4.823-2.142a1.05 1.05 0 0 0 .654-.947l.2-4.484a1.11 1.11 0 0 0-.99-1.207l-4.18-.002zm-2.022 3.96c-.168 0-.317.077-.441.229-.124.153-.204.356-.204.59 0 .23.08.454.24.59.159.137.31.23.465.232.156-.002.318-.095.443-.233.125-.137.207-.356.207-.59a.63.63 0 0 0-.207-.585c-.125-.135-.28-.228-.444-.23z"/>
      </svg>
    ),
    label: 'Telegram',
  },
  {
    name: 'TikTok',
    href: 'https://www.tiktok.com/@pastordavidogbueli',
    icon: (
      <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.37-4.81 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
      </svg>
    ),
    label: 'TikTok',
  },
  {
    name: 'WhatsApp',
    href: 'https://api.whatsapp.com/send?phone=2348103526864',
    icon: (
      <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.868-2.031-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
      </svg>
    ),
    label: 'WhatsApp',
  },
];

export function PublicFooter() {
  return (
    <footer className="border-t border-zinc-800 bg-zinc-950">
      <div className="container mx-auto max-w-7xl px-4 py-16">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center space-x-3 group">
              <div className="relative h-10 w-10">
                <img
                  src="/logo.png"
                  alt="Dominion Mandate"
                  className="object-contain group-hover:scale-110 transition-transform rounded-full"
                />
              </div>
              <span className="font-bold text-xl text-white">Dominion Mandate</span>
            </Link>
            <p className="text-sm text-white/60 leading-relaxed">
              Raising Leaders That Transform Society. Connecting believers worldwide through 
              secure live worship, powerful teachings, and authentic community.
            </p>
            <div className="flex items-center gap-4 pt-2">
              {SOCIAL_LINKS.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/40 hover:text-primary transition-colors"
                  aria-label={link.label}
                >
                  {link.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Platform */}
          <div className="space-y-4">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider">Platform</h3>
            <nav className="flex flex-col space-y-3">
              <Link
                to="/broadcast"
                className="text-sm text-white/60 hover:text-white transition-colors flex items-center"
              >
                <span className="w-2 h-px bg-primary mr-2 transition-all" />
                Live Streaming
              </Link>
              <Link
                to="/signin"
                className="text-sm text-white/60 hover:text-white transition-colors flex items-center"
              >
                <span className="w-2 h-px bg-primary mr-2 transition-all" />
                Sign In
              </Link>
            </nav>
          </div>

          {/* Community */}
          <div className="space-y-4">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider">Community</h3>
            <nav className="flex flex-col space-y-3">
              <Link 
                to="/about" 
                className="text-sm text-white/60 hover:text-white transition-colors flex items-center"
              >
                <span className="w-2 h-px bg-primary mr-2 transition-all" />
                About Us
              </Link>
              <Link 
                to="/leadership" 
                className="text-sm text-white/60 hover:text-white transition-colors flex items-center"
              >
                <span className="w-2 h-px bg-primary mr-2 transition-all" />
                Leadership
              </Link>
              <Link 
                to="/give" 
                className="text-sm text-white/60 hover:text-white transition-colors flex items-center"
              >
                <span className="w-2 h-px bg-primary mr-2 transition-all" />
                Give
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider">Contact</h3>
            <div className="flex flex-col space-y-4 text-sm">
              <div className="flex items-start gap-3 text-white/60 group">
                <MapPin className="h-4 w-4 mt-0.5 text-primary shrink-0" />
                <span className="group-hover:text-white/80 transition-colors">
                  Golden Heart Place, Km 22<br />
                  Lekki-Epe Expressway, After Alasia Bus-stop<br />
                  Ajah, Lagos, Nigeria
                </span>
              </div>
              <a href="mailto:feedback@dclagoshq.com" className="flex items-center gap-3 text-white/60 hover:text-white transition-colors group">
                <Mail className="h-4 w-4 text-primary shrink-0" />
                feedback@dclagoshq.com
              </a>
              <a href="tel:+2348036717532" className="flex items-center gap-3 text-white/60 hover:text-white transition-colors group">
                <Phone className="h-4 w-4 text-primary shrink-0" />
                +234 803 671 7532
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-zinc-800">
          <div className="flex flex-col items-center justify-between space-y-4 md:flex-row md:space-y-0">
            <p className="text-sm text-white/40">
              © {new Date().getFullYear()} Dominion Mandate Platform. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-sm text-white/40">
              <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
              <Link to="/help" className="hover:text-white transition-colors">Help Center</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
